$('.block__test-drive-faqs-header').on('click', function(){
    if(!$(this).parent().hasClass('active')){
        $(this).closest('.block__test-drive-faqs-items-wrapper').find('.block__test-drive-faqs-item').removeClass('active')
        $(this).parent().addClass('active');
        $(this).closest('.block__test-drive-faqs-items-wrapper').find('.block__test-drive-faqs-item-content').slideUp(); 
        $(this).siblings('.block__test-drive-faqs-item-content').slideDown();
    }
});
$(document).ready(function(){
    if(window.innerWidth > 1024){
        let image_height =   $('.block__test-drive-faqs-items-wrapper').innerHeight() + $('.block__test-drive-faqs-heading').innerHeight() + 40; 
        $('.block__test-drive-faqs-image').css('height', image_height); 
    }
})